"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresParameterTAccountsSumConfigs = void 0;
const validatePostgresParameterTAccountsSumConfigs = (params) => {
    const { configs, tAccountDetails } = params;
    const errors = [];
    configs.forEach((config) => {
        const { accountDetails } = config;
        accountDetails.forEach((accountDetail) => {
            if (!tAccountDetails.some((tAccountDetail) => tAccountDetail.counterpartySlug ===
                accountDetail.counterpartySlug &&
                tAccountDetail.tAccount === accountDetail.tAccount)) {
                errors.push(`Postgres parameter tAccounts sum config contains invalid tAccount detail: [${JSON.stringify(accountDetail)}]. Valid tAccount details: ${JSON.stringify(tAccountDetails)}`);
            }
        });
    });
    return { errors };
};
exports.validatePostgresParameterTAccountsSumConfigs = validatePostgresParameterTAccountsSumConfigs;
//# sourceMappingURL=postgresParameterTAccountsSumConfigs.js.map